/* src/app/components/header/header.component.scss */
button:focus {
  outline-color: #380415;
}
#mainNav {
  border-bottom: 1px solid rgba(33, 37, 41, 0.1);
  padding: 0.1rem 0rem;
  line-height: 1.3em;
  font-family:
    Raleway,
    "Helvetica Neue",
    Arial,
    sans-serif;
  font-display: swap;
  -webkit-transition: all 0.2s;
  -moz-transition: all 0.2s;
  transition: all 0.2s;
}
#mainNav a {
  cursor: pointer;
}
#mainNav .navbar-toggler-inv {
  display: none;
}
#mainNav .nav-menu-icon {
  transform: scale(1.3);
}
#mainNav .navbar-buttons {
  display: inline-block;
}
#mainNav .navbar-buttons > button {
  display: inline-block;
}
#mainNav .navbar-title {
  display: none;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.7);
  padding-top: 0px;
  font-size: 1.25rem;
}
#mainNav .navbar-title.navbar-inicial {
  opacity: 0;
  transition: opacity 0.5s ease-in;
}
#mainNav .navbar-brand {
  font-weight: 700;
  color: #212529;
  padding-bottom: 0px;
  margin-right: 4px;
}
#mainNav .navbar-brand > .icon {
  display: inline-block;
  margin-right: 0;
  width: 100px;
  height: 30px;
  opacity: 0.8;
  background-repeat: no-repeat;
  background-image: url(data:image/svg+xml;charset=utf8,%3Csvg%20id%3D%22b%22%20data-name%3D%22LogoBolCo%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22100%22%20height%3D%2230%22%20viewBox%3D%220%200%20100%2030%22%3E%20%20%3Cpath%20d%3D%22M15.007,14.713c.76-.498,1.336-1.142,1.726-1.932,.39-.789,.585-1.64,.585-2.555,0-.851-.15-1.63-.45-2.336-.3-.706-.731-1.313-1.291-1.822-.56-.509-1.246-.903-2.056-1.184-.81-.28-1.736-.421-2.776-.421H1.5V25.648H6.513v-2.212c.7,.914,1.451,1.547,2.251,1.9,.8,.353,1.761,.53,2.881,.53s2.086-.156,2.896-.467,1.486-.742,2.026-1.293c.54-.55,.94-1.194,1.201-1.932,.26-.737,.39-1.531,.39-2.383,0-1.059-.265-2.051-.795-2.975-.53-.924-1.316-1.625-2.356-2.103ZM6.513,8.731h3.392c.72,0,1.3,.166,1.741,.498,.44,.332,.66,.852,.66,1.558,0,.685-.21,1.215-.63,1.589-.42,.374-.981,.561-1.681,.561h-3.482v-4.206Zm5.898,12.056c-.41,.395-1.016,.592-1.816,.592H6.513v-4.393h4.172c.7,0,1.265,.182,1.696,.545,.43,.364,.645,.899,.645,1.604s-.205,1.257-.615,1.651Z%22%20fill%3D%22%23fff%22%2F%3E%20%20%3Cpath%20d%3D%22M34.277,12.284c-1.421-1.291-3.372-1.936-5.853-1.936-2.461,0-4.412,.645-5.853,1.936-1.441,1.291-2.161,3.247-2.161,5.868,0,2.602,.72,4.553,2.161,5.853,1.441,1.301,3.392,1.951,5.853,1.951,2.481,0,4.432-.65,5.853-1.951,1.421-1.3,2.131-3.251,2.131-5.853,0-2.621-.711-4.577-2.131-5.868Zm-3.512,8.9c-.5,.741-1.281,1.111-2.341,1.111-1.041,0-1.816-.37-2.326-1.111-.51-.74-.765-1.751-.765-3.032s.255-2.291,.765-3.032c.51-.74,1.286-1.111,2.326-1.111,1.06,0,1.841,.37,2.341,1.111,.5,.741,.75,1.751,.75,3.032s-.25,2.291-.75,3.032Z%22%20fill%3D%22%23fff%22%2F%3E%20%20%3Cpath%20d%3D%22M96.369,12.284c-1.421-1.291-3.372-1.936-5.853-1.936-2.461,0-4.412,.645-5.853,1.936-1.441,1.291-2.161,3.247-2.161,5.868,0,2.602,.72,4.553,2.161,5.853,1.441,1.301,3.392,1.951,5.853,1.951,2.481,0,4.432-.65,5.853-1.951,1.421-1.3,2.131-3.251,2.131-5.853,0-2.621-.711-4.577-2.131-5.868Zm-3.512,8.9c-.5,.741-1.281,1.111-2.341,1.111-1.041,0-1.816-.37-2.326-1.111-.51-.74-.765-1.751-.765-3.032s.255-2.291,.765-3.032c.51-.74,1.286-1.111,2.326-1.111,1.06,0,1.841,.37,2.341,1.111,.5,.741,.75,1.751,.75,3.032s-.25,2.291-.75,3.032Z%22%20fill%3D%22%23fff%22%2F%3E%20%20%3Cpath%20d%3D%22M77.993,25.533c.498-.06,.962-.124,1.394-.194,.431-.07,.791-.144,1.079-.224,.088-.219,.171-.498,.249-.837,.077-.339,.144-.703,.199-1.091,.055-.389,.099-.772,.133-1.151,.033-.378,.05-.698,.05-.957-.332,.08-.73,.15-1.195,.209-.465,.06-.974,.115-1.527,.165-.553,.05-1.117,.09-1.693,.12-.576,.03-1.128,.045-1.659,.045-1.947,0-3.413-.538-4.397-1.615-.985-1.077-1.477-2.661-1.477-4.755s.492-3.678,1.477-4.755c.984-1.077,2.45-1.615,4.397-1.615,.42,0,.89,.015,1.41,.045,.52,.03,1.034,.07,1.543,.12,.509,.05,.984,.11,1.427,.179,.443,.07,.797,.135,1.062,.194,.088-.219,.171-.498,.249-.837,.077-.339,.144-.698,.199-1.077,.055-.378,.099-.757,.133-1.136,.033-.379,.05-.707,.05-.987-.332-.079-.742-.154-1.228-.224-.487-.07-1.001-.135-1.543-.194-.542-.06-1.095-.105-1.659-.135-.564-.03-1.112-.045-1.643-.045-1.792,0-3.402,.209-4.829,.628-1.427,.419-2.639,1.062-3.634,1.929-.996,.867-1.759,1.959-2.29,3.274-.531,1.316-.797,2.861-.797,4.635s.266,3.319,.797,4.635c.368,.913,.851,1.715,1.443,2.412h-22.065V4.044h-4.802V23.879c0,.981,.795,1.776,1.776,1.776h3.026%22%20fill%3D%22%23fff%22%2F%3E%20%20%3Cpolygon%20points%3D%2295.259%206.711%2094.023%204.502%2088.999%207.421%2089.999%209.183%2095.259%206.711%22%20fill%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E);
}
#mainNav.navbar-shrink {
  background-color: #380415;
}
#mainNav .container {
  max-width: 1024px;
  padding: 0 0.4em;
}
#mainNav .navbar-nav > li.nav-item .ng-fa-icon {
  padding-right: 10px;
}
#mainNav .navbar-nav > li.nav-item > a.nav-link,
#mainNav .navbar-nav > li.nav-item > a.nav-link:focus {
  font-size: 0.9rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #212529;
}
#mainNav .navbar-nav > li.nav-item > a.nav-link.active,
#mainNav .navbar-nav > li.nav-item > a.nav-link:focus.active {
  color: #380415 !important;
  background-color: transparent;
}
#mainNav .navbar-nav > li.nav-item > a.nav-link.active:hover,
#mainNav .navbar-nav > li.nav-item > a.nav-link:focus.active:hover {
  background-color: transparent;
}
@media (min-width: 992px) {
  #mainNav {
    border-color: transparent;
    background-color: transparent;
  }
  #mainNav .navbar-brand {
    color: rgba(255, 255, 255, 0.7);
  }
  #mainNav .navbar-brand:focus,
  #mainNav .navbar-brand:hover {
    color: white;
  }
  #mainNav .navbar-brand > .icon {
    opacity: 0.8;
  }
  #mainNav .navbar-toggler-inv {
    display: inline-block;
  }
  #mainNav .navbar-nav > li.nav-item > a.nav-link {
    padding: 0.5rem 1rem;
  }
  #mainNav .navbar-nav > li.nav-item > a.nav-link,
  #mainNav .navbar-nav > li.nav-item > a.nav-link:focus {
    color: rgba(255, 255, 255, 0.7);
  }
  #mainNav .navbar-nav > li.nav-item > a.nav-link:hover,
  #mainNav .navbar-nav > li.nav-item > a.nav-link:focus:hover {
    color: white;
  }
  #mainNav.navbar-shrink {
    -webkit-box-shadow: 0 0 20px 1px #000;
    -moz-box-shadow: 0 0 20px 1px #000;
    box-shadow: 0 0 20px 1px #000;
    border-bottom: 1px solid rgba(33, 37, 41, 0.1);
    background-color: white;
  }
  #mainNav.navbar-shrink .navbar-title {
    display: none;
    color: #495057;
  }
  #mainNav.navbar-shrink .navbar-title.navbar-inicial {
    opacity: 1;
  }
  #mainNav.navbar-shrink .navbar-brand {
    color: #380415;
  }
  #mainNav.navbar-shrink .navbar-brand:focus,
  #mainNav.navbar-shrink .navbar-brand:hover {
    color: rgb(8.4, 0.6, 3.15);
  }
  #mainNav.navbar-shrink .navbar-brand > .icon {
    padding-top: 5px;
    background-image: url(data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20viewBox%3D%220%200%2030%2030%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Aurl%28%23linear-gradient%29%3B%7D.cls-2%7Bfill%3Aurl%28%23linear-gradient-2%29%3B%7D.cls-3%7Bfill%3A%23e16d19%3B%7D.cls-4%7Bfill%3Aurl%28%23linear-gradient-3%29%3B%7D.cls-5%7Bfill%3A%23fff%3B%7D.cls-6%7Bfill%3Anone%3Bstroke%3A%2357423a%3Bstroke-miterlimit%3A10%3Bstroke-width%3A0.47px%3B%7D%3C%2Fstyle%3E%3ClinearGradient%20id%3D%22linear-gradient%22%20x1%3D%2215%22%20x2%3D%2215%22%20y2%3D%2230%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%23faed64%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23ecbf3f%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22linear-gradient-2%22%20x1%3D%222.5%22%20y1%3D%2213.39%22%20x2%3D%2229.43%22%20y2%3D%2213.39%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%235187e1%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%232c499d%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22linear-gradient-3%22%20x1%3D%2215.68%22%20y1%3D%2215%22%20x2%3D%2228.7%22%20y2%3D%2215%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%238db14c%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%235c8d44%22%2F%3E%3C%2FlinearGradient%3E%3C%2Fdefs%3E%3Ctitle%3Eicon_color_30%3C%2Ftitle%3E%3Cg%20id%3D%22icon_color%22%3E%3Crect%20class%3D%22cls-1%22%20width%3D%2230%22%20height%3D%2230%22%20rx%3D%223%22%20ry%3D%223%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M2.5%2C7.09c2.62%2C8.18%2C9.77%2C13.22%2C16.59%2C12.54%2C6-.6%2C9.59-5.36%2C10.34-6.4%22%2F%3E%3Cpolygon%20class%3D%22cls-3%22%20points%3D%2218.85%2024.61%202.6%2023.75%200.63%2014.77%2018.44%2016.02%2018.85%2024.61%22%2F%3E%3Cpolygon%20class%3D%22cls-3%22%20points%3D%2221.09%2025.1%2019.22%2024.84%2018.91%2017.71%2021.09%2017.71%2021.09%2025.1%22%2F%3E%3Cpolygon%20class%3D%22cls-3%22%20points%3D%2223.13%2025.14%2021.52%2024.92%2021.25%2018.81%2023.13%2018.81%2023.13%2025.14%22%2F%3E%3Cellipse%20class%3D%22cls-4%22%20cx%3D%2222.19%22%20cy%3D%2215%22%20rx%3D%226.51%22%20ry%3D%222.34%22%2F%3E%3Ccircle%20class%3D%22cls-5%22%20cx%3D%2220.94%22%20cy%3D%229.06%22%20r%3D%225.94%22%2F%3E%3Cpolygon%20class%3D%22cls-3%22%20points%3D%2225%2025.63%2023.66%2025.44%2023.44%2020.35%2025%2020.35%2025%2025.63%22%2F%3E%3Cpath%20d%3D%22M5.4%2C11.12H9.65a4.69%2C4.69%2C0%2C0%2C1%2C2.93.79%2C2.66%2C2.66%2C0%2C0%2C1%2C1%2C2.25A2.81%2C2.81%2C0%2C0%2C1%2C13.08%2C16a2.36%2C2.36%2C0%2C0%2C1-1.54.83A3.07%2C3.07%2C0%2C0%2C1%2C14.12%2C20%2C3.07%2C3.07%2C0%2C0%2C1%2C13%2C22.51a5%2C5%2C0%2C0%2C1-3.18.9H5.4Zm1.67%2C1.37v3.7H9.53a2.93%2C2.93%2C0%2C0%2C0%2C1.81-.46%2C1.63%2C1.63%2C0%2C0%2C0%2C.6-1.39%2C1.63%2C1.63%2C0%2C0%2C0-.6-1.39%2C2.93%2C2.93%2C0%2C0%2C0-1.81-.46Zm0%2C5V22H9.73a3%2C3%2C0%2C0%2C0%2C2-.56%2C2.11%2C2.11%2C0%2C0%2C0%2C.65-1.7%2C2.09%2C2.09%2C0%2C0%2C0-.65-1.69%2C3%2C3%2C0%2C0%2C0-2-.55Z%22%2F%3E%3Cpath%20d%3D%22M20.47%2C14a3.92%2C3.92%2C0%2C0%2C1%2C3.11%2C1.28%2C5.22%2C5.22%2C0%2C0%2C1%2C1.12%2C3.56%2C5.23%2C5.23%2C0%2C0%2C1-1.12%2C3.55%2C3.92%2C3.92%2C0%2C0%2C1-3.11%2C1.28%2C3.89%2C3.89%2C0%2C0%2C1-3.1-1.28%2C5.23%2C5.23%2C0%2C0%2C1-1.13-3.55%2C5.23%2C5.23%2C0%2C0%2C1%2C1.13-3.56A3.89%2C3.89%2C0%2C0%2C1%2C20.47%2C14Zm0%2C1.28a2.27%2C2.27%2C0%2C0%2C0-1.92.95%2C4.28%2C4.28%2C0%2C0%2C0-.71%2C2.61%2C4.27%2C4.27%2C0%2C0%2C0%2C.7%2C2.6%2C2.43%2C2.43%2C0%2C0%2C0%2C3.85%2C0%2C4.31%2C4.31%2C0%2C0%2C0%2C.71-2.6%2C4.29%2C4.29%2C0%2C0%2C0-.71-2.6A2.26%2C2.26%2C0%2C0%2C0%2C20.47%2C15.25Zm1.15-5.32h1.63L20.57%2C13H19.31Z%22%2F%3E%3Cline%20class%3D%22cls-6%22%20x1%3D%2228.7%22%20y1%3D%2229.18%22%20x2%3D%2228.7%22%20y2%3D%2217.34%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E);
  }
  #mainNav.navbar-shrink .navbar-nav > li.nav-item > a.nav-link,
  #mainNav.navbar-shrink .navbar-nav > li.nav-item > a.nav-link:focus {
    color: #212529;
  }
  #mainNav.navbar-shrink .navbar-nav > li.nav-item > a.nav-link:hover,
  #mainNav.navbar-shrink .navbar-nav > li.nav-item > a.nav-link:focus:hover {
    color: rgb(8.4, 0.6, 3.15);
  }
  #mainNav.navbar-shrink .top-button {
    color: #495057;
  }
  #mainNav.navbar-shrink .top-button:hover {
    color: #fff;
    background-color: rgba(103, 58, 183, 0.2);
  }
}
#mainNav .top-button {
  font-weight: 700;
  color: rgba(255, 255, 255, 0.7);
  padding-top: 0px;
  font-size: 0.9rem;
  align-self: flex-end;
  text-transform: uppercase;
}
#mainNav .top-button:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.2);
}
#mainNav .navbar-resp-menu .navbar-toggler-icon {
  display: inline-block;
  vertical-align: middle;
}
#mainNav .navbar-resp-menu {
  justify-content: flex-end;
  font-size: 19px;
}
@media (min-width: 992px) {
  ::ng-deep button.mat-menu-item.only_responsive {
    display: none;
  }
}
.modal-content {
  background-color: #f7f7f7;
  border-radius: 2px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}
.modal-container {
  padding: 30px;
  max-width: 380px;
  width: 100% !important;
  margin: 0 auto;
  border-radius: 2px;
  overflow: hidden;
  font-family:
    Raleway,
    "Helvetica Neue",
    Arial,
    sans-serif;
  font-display: swap;
}
.modal-container h1 {
  text-align: center;
  font-size: 1.8rem;
}
.modal-container h2 {
  text-align: center;
  font-size: 1.5em;
}
.modal-container h3.traco {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #000;
  line-height: 0.1em;
  margin: 10px 0 20px;
}
.modal-container h3.traco span {
  background: #fff;
  padding: 0 10px;
}
.modal-container .form-field {
  min-width: 150px;
  max-width: 500px;
  width: 100%;
}
.loginmodal {
  text-align: center;
  font-size: 14px;
  font-family: "Arial", sans-serif;
  font-weight: 700;
  height: 36px;
  padding: 0 8px;
}
.loginmodal-login {
  border: 0px;
  font-weight: 700;
  padding: 6px 12px;
  font-size: 14px;
  width: 193px;
}
.modal-buttons {
  width: 100%;
}
.modal-buttons button {
  width: 100%;
  margin: 10px 0px;
  padding: 6px;
  align-items: center;
}
.registerModal-icon {
  width: 30px;
  height: 30px;
  float: left;
  margin: 3px;
  vertical-align: middle;
}
.google-icon {
  background: url("data:image/svg+xml,%3Csvg enable-background='new 0 0 533.5 544.3' version='1.1' viewBox='0 0 533.5 544.3' xml:space='preserve' xmlns='http://www.w3.org/2000/svg' xmlns:cc='http://creativecommons.org/ns%23' xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:ns='&amp;ns_sfw;' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23'%3E%3Cpath d='m533.5 278.4c0-18.5-1.5-37.1-4.7-55.3h-256.7v104.8h147c-6.1 33.8-25.7 63.7-54.4 82.7v68h87.7c51.5-47.4 81.1-117.4 81.1-200.2z' style='fill:%234285f4'/%3E%3Cpath d='m272.1 544.3c73.4 0 135.3-24.1 180.4-65.7l-87.7-68c-24.4 16.6-55.9 26-92.6 26-71 0-131.2-47.9-152.8-112.3h-90.5v70.1c46.2 91.9 140.3 149.9 243.2 149.9z' style='fill:%2334a853'/%3E%3Cpath d='M119.3,324.3c-11.4-33.8-11.4-70.4,0-104.2V150H28.9c-38.6,76.9-38.6,167.5,0,244.4L119.3,324.3z' style='fill:%23fbbc04'/%3E%3Cpath d='m272.1 107.7c38.8-0.6 76.3 14 104.4 40.8l77.7-77.7c-49.2-46.2-114.5-71.6-182.1-70.8-102.9 0-197 58-243.2 150l90.4 70.1c21.5-64.5 81.8-112.4 152.8-112.4z' style='fill:%23ea4335'/%3E%3C/svg%3E") no-repeat;
}
.registerEmailModal-buttons {
  width: 100%;
}
.registerEmailModal-buttons button {
  width: 50%;
  padding: 6px 12px;
}
.loginmodal-submit:hover {
  border: 0px;
  text-shadow: 0 1px rgba(0, 0, 0, 0.3);
  background-color: #380415;
}
.loginmodal-container a {
  text-decoration: none;
  color: #666;
  font-weight: 400;
  text-align: center;
  display: inline-block;
  opacity: 0.6;
  transition: opacity ease 0.5s;
}
.login-help {
  font-size: 13px;
  padding-bottom: 20px;
  margin-top: 15px;
}
.login-help a {
  cursor: pointer;
}
.login-help a:hover,
.login-help a:focus,
.login-help a:active {
  color: #380415;
}
.login-buttons {
  text-align: center;
}
.login-buttons img {
  cursor: pointer;
  border: 1px solid white;
}
.login-buttons img:hover,
.login-buttons img:focus,
.login-buttons img:active {
  border: 1px solid #380415;
}
.login-buttons img:active,
.login-buttons img:focus {
  box-shadow: 0 0 0 0.2rem #da8505 !important;
}
.no-connection {
  display: block;
  width: 12rem;
  background-color: red;
  color: white;
  text-align: center;
}
@media (max-width: 350px) {
  .navbar-brand {
    display: none;
  }
}
.mat-menu-item:hover {
  background-color: #673ab7;
  color: white;
}
.mat-menu-item:hover .mat-icon {
  color: white;
}
.but-menu {
  color: #380415;
}
.but-menu .but-icon-menu {
  color: #380415;
}
.but-menu:hover {
  color: white;
}
.but-menu:hover .but-icon-menu {
  color: white;
}
/*# sourceMappingURL=header.component-UIJJR4CT.css.map */
